import {useDispatch, useSelector} from "react-redux";
import {useCallback, useState} from "react";
import * as actions from "../../../../../../../../store";
import {TableCell, TableRow, Typography} from "@material-ui/core";
import EmptyRow from "../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import SimpleTable from "../../../../../../../../shared/components/tables/simple-table/SimpleTable";
import DetailsDialog from "./details-dialog/DetailsDialog";
import PropTypes from "prop-types";
import {useParams} from "react-router-dom";
import {headCells, headCellsPiano} from "./OffertePianoOpzioneTableHelper";
import OfferteDetailsDialog
    from "../../../../../ordini-consip/ordini-consip-details/ordini-consip-tabs/offerte/offerte-details/OfferteDetailsDialog";
import Button from "@material-ui/core/Button";
import {Call, SmsOutlined, Wifi} from "@material-ui/icons";
import * as actionTypes from "../../../../../../../../store/contratto-digitale/actionTypes";

const OffertePianoOpzioneTable = (props) => {
    const dispatch = useDispatch()
    const {consipId} = useParams()

    const [openPlanDetailsDialog, setOpenPlanDetailsDialog] = useState(false)
    const [planCardsData, setPlanCardsData] = useState({familyName: ''})
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const [openOfferteDetailsDialog, setOpenOfferteDetailsDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null)
    const [isPlafondShare, setIsPlafondShare] = useState(false);
    const [itemName, setItemName] = useState("");

    const handleOpenPianoDetails = useCallback((row) => {
        setPlanCardsData(row)
        if (props.comesFromConsip) {
            if (!props.isPachetti) {
                dispatch(actions.getOfferteRowDetails(integrationId, consipId, row.commercialLabel))
                setOpenOfferteDetailsDialog(true);
            }
        } else {
            setSelectedRow(row)
            setOpenPlanDetailsDialog(true)
        }
    }, [dispatch, consipId, integrationId, props.comesFromConsip, props.isPachetti])


    const tableRowClick = useCallback((row, itemName, isPlafondShare) => {
        if (!props.hasTableRowClick)
            return;
        setIsPlafondShare(isPlafondShare);
        setItemName(itemName)
        return handleOpenPianoDetails(row);
    }, [props.hasTableRowClick, handleOpenPianoDetails])

    const tableRows = useCallback(() => {
        return (
            props.data && props.data.length > 0 ? props.data.map((row, idx) => (
                props.optionsTable || props.comesFromConsip || props.isPachetti ?
                    <TableRow key={`digital-contract-piano-table-row-${idx}`}
                              hover={props.hasTableRowClick}
                              onClick={() => tableRowClick(row, row.itemName,  false)}>
                        <TableCell component="th" scope="row">
                            <Typography variant="subtitle2">{row.itemName}</Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant="subtitle2">{row.activationPriceDisplayValue}</Typography>
                        </TableCell>
                        {!props.isPachetti &&
                            <TableCell align="left">
                                <Typography variant="subtitle2">{row.monthlyPriceDisplayValue}</Typography>
                            </TableCell>
                        }
                        <TableCell align="left">
                            <Typography variant="subtitle2">{row.numberOfSimsDisplayValue}</Typography>
                        </TableCell>
                        {!props.isPachetti &&
                            <TableCell align="left">
                                <Typography variant="subtitle2">{row.tipologia}</Typography>
                            </TableCell>
                        }
                    </TableRow>
                    :
                    <>
                        <TableRow key={`digital-contract-piano-name-${idx}`}
                                  hover={props.hasTableRowClick}>
                            <TableCell component="th" scope="row" style={{borderBottom:"none"}}>
                                <Typography variant="subtitle2">{row.itemName}</Typography>
                            </TableCell>
                        </TableRow>
                        <TableRow key={`digital-contract-piano-singolo-${idx}`}
                                  hover={props.hasTableRowClick}>
                            <TableCell
                                component="th"
                                scope="row"
                                style={{
                                    paddingLeft: "5em",
                                    position: "relative",
                                    borderBottom:"none"
                                }}
                            >
                                <div style={{
                                    position: "absolute",
                                    left: "0",
                                    right: "0",
                                    bottom: "0",
                                    borderBottom: "1.3px solid #e0e0e0",
                                    marginLeft: "4em",
                                    paddingBottom:"1em"
                                }}>
                                    <Typography variant="overline" style={{marginBottom:"2em"}}>Plafond singolo</Typography>
                                </div>
                            </TableCell>
                            <TableCell align="left">
                                <Typography variant="subtitle2">{row.numberOfSimsDisplayValue}</Typography>
                            </TableCell>
                            {!props.isPachetti &&
                                <TableCell align="left">
                                    <Typography variant="subtitle2">{row.tipologia}</Typography>
                                </TableCell>
                            }
                            <TableCell align="left">
                                <Typography variant="subtitle2">{row.monthlyPriceDisplayValue}</Typography>
                            </TableCell>
                            {!props.isPachetti &&
                                <TableCell align="left">
                                    <Typography variant="subtitle2">{row.activationPriceDisplayValue}</Typography>
                                </TableCell>
                            }
                            <TableCell align="left">
                                <Button variant="text"
                                        color={"primary"}
                                        style={{padding:0}}
                                        onClick={() => tableRowClick(row, row.itemName, false)}>
                                    Dettagli
                                </Button>
                            </TableCell>
                        </TableRow>
                        {row.plafondSharesList && row.plafondSharesList.length > 0 && row.plafondSharesList.map((item, id) => (
                            <TableRow key={`digital-contract-piano-plafond-${idx}-${id}`}
                                      hover={props.hasTableRowClick}>
                                <TableCell component="th" scope="row" style={{paddingLeft: "4em", borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Typography variant="overline">Plafond Condiviso <br></br> {item.nomePlafondShare}</Typography>
                                    {item.areIconsVisible &&
                                    <Typography>
                                        <Call style={{color: item.phoneIconEnabled ? "#63cf38" : "#cacaca", fontSize:"medium", marginRight:"1em"}}/>
                                        <SmsOutlined style={{color: item.smsIconEnabled ? "#63cf38" : "#cacaca", fontSize:"medium", marginRight:"1em"}}/>
                                        <Wifi style={{color: item.wifiIconEnabled ? "#63cf38" : "#cacaca", fontSize:"medium", marginRight:"1em"}}/>
                                    </Typography>}
                                </TableCell>
                                <TableCell align="left" style={{borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Typography variant="subtitle2">{item.numberOfSimsDisplayValue}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Typography variant="subtitle2">{item.tipologia}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Typography variant="subtitle2">{item.monthlyPriceDisplayValue}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Typography variant="subtitle2">{item.activationPriceDisplayValue}</Typography>
                                </TableCell>
                                <TableCell align="left" style={{borderBottom: row.plafondSharesList.length === id+1 ?"auto" : "none"}}>
                                    <Button variant="text"
                                            color={"primary"}
                                            style={{padding:0}}
                                            onClick={() => tableRowClick(item, row.itemName, true)}>Dettagli</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </>
            )) : <EmptyRow text='dato' colSpan={headCells(props.isPachetti).length}/>
        )
    }, [props.data, tableRowClick, props.hasTableRowClick, props.isPachetti])

    const handleDialogClose = () => {
        dispatch({type: actionTypes.GET_SIMS_ASSOCIATED_TO_PLAN_DATA_OR_LOADING, value: false, key: 'error'})
        setOpenPlanDetailsDialog(false)
    }

    return (
        <>
            <SimpleTable
                tableRows={tableRows()}
                headCells={props.optionsTable ? headCells(props.isPachetti) : headCellsPiano}
                loading={props.loading}
            />

            {openPlanDetailsDialog ? <DetailsDialog
                    arePianoDetails={!planCardsData.familyName?.toLowerCase().includes('option')}
                    isPlafondShare={isPlafondShare}
                    itemName={itemName}
                    open={openPlanDetailsDialog}
                    planCardsData={planCardsData}
                    selectedRow={selectedRow}
                    handleDialogClose={handleDialogClose}/>
                : null}
            {openOfferteDetailsDialog ?
                <OfferteDetailsDialog
                    open={openOfferteDetailsDialog}
                    planCardsData={planCardsData}
                    handleDialogClose={() => setOpenOfferteDetailsDialog(false)}
                />
                : null}
        </>
    )
}

OffertePianoOpzioneTable.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    hasTableRowClick: PropTypes.bool.isRequired,
    comesFromConsip: PropTypes.bool,
    isPachetti: PropTypes.bool
}

OffertePianoOpzioneTable.defaultProps = {
    comesFromConsip: false,
    isPachetti: false
}

export default OffertePianoOpzioneTable;
